"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {findIn} from "@elements/dom-utils";
import {getApi} from "@elements/datepicker";

export function init() {
    onFind('.js-datepicker-range--fixed', function (datePickerRange) {
        let offset = datePickerRange.dataset.datepickerRangeFixedDays;
        let datePickerTo = findIn('.js-datepicker-range__to', datePickerRange);
        let datePickerFrom = findIn('.js-datepicker-range__from', datePickerRange);

        if(offset) {
            datePickerFrom.addEventListener('change', function(){
                Promise.all([getApi(datePickerFrom)]).then(function([api]) {
                    let currentDate = api.getDate();
                    let newDate = new Date(Number(currentDate));
                    newDate = newDate.setDate(currentDate.getDate() + +offset);
                    Promise.all([getApi(datePickerTo)]).then(function([api]) {
                        api.setDate(new Date(newDate));
                    });
                });
            })
        }
    });
}
